import View from "../../../Nav/Js/views/PubliAccordion";
import components from "./components.js";
components.define("js-PubliAccordion", View);